import { render, staticRenderFns } from "./ResourceCreate.vue?vue&type=template&id=9d8b91d0&"
import script from "./ResourceCreate.vue?vue&type=script&lang=js&"
export * from "./ResourceCreate.vue?vue&type=script&lang=js&"
import style0 from "./ResourceCreate.vue?vue&type=style&index=0&id=9d8b91d0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports